// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__sGhJc","column":"style_column__2vGQE","row":"style_row__1fgIr"};